import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { OrganizationDataPickerComponent } from './organization-data-picker.component';

@NgModule({
  declarations: [
    OrganizationDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    OrganizationDataPickerComponent
  ]
})
export class OrganizationDataPickerModule { }
